export enum Pages {
  CHORD = '/chord',
  SCALE = '/scale',
  CAGED = '/caged',
  HARMONY = '/harmony',
  HELP = '/help',
}
